import { useQuery } from "@apollo/client";
import { authState } from "atoms/auth";
import { AVG_SCHEMA_SCORE } from "graphql/quiz";
import { toNumber } from "lodash";
import Rate from "rc-rate";
import { NavLink } from "react-router-dom";
import { useSpring, animated } from "react-spring";
import { useRecoilValue } from "recoil";
import { getCurrentContent } from "selectors/controller";
import { appStrings } from "utils/appStrings";
import { calculateScore } from "utils/functions";
import { toPersian } from "utils/raqam";

const Result: React.FC = () => {
  const content = useRecoilValue(getCurrentContent);
  const auth = useRecoilValue(authState);

  const getQueryStringValue = (key: string) => {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          "^(?:.*[&\\?]" +
            encodeURIComponent(key).replace(/[*]/g, "\\$&") +
            "(?:\\=([^&]*))?)?.*$",
          "i"
        ),
        "$1"
      )
    );
  };

  const qt = getQueryStringValue("qt");

  const { data, loading } = useQuery(AVG_SCHEMA_SCORE, {
    variables: {
      schema_id: toNumber(content.schemaID),
    },
  });

  const animation = useSpring({
    transform: "scale(1)",
    from: { transform: "scale(0)" },
  });

  const url = `${window.location.origin}/result?qt=${content.token || qt}&qi=${
    content.id
  }`;

  return (
    <animated.div style={animation} className="w-full">
      <div dir="ltr" className="text-center w-full">
        <Rate
          count={5}
          defaultValue={calculateScore(content.score)}
          direction="ltr"
          disabled
          allowHalf={true}
          style={{ fontSize: "48px", margin: "auto" }}
        />
        <p className="text-2xl dark:text-gray-100">
          {appStrings.yourScore}{" "}
          <strong className="text-secondary-800 dark:text-secondary-300">
            {appStrings.scoreDivision(content.score, 100)}
          </strong>
        </p>
        <p className="mt-3">
          <span className="ml-2">{appStrings.avgScore}</span>
          <span className="font-semibold text-secondary-800">
            {!loading && data.QUIZ_average_score
              ? toPersian(data.QUIZ_average_score, {})
              : "-"}
          </span>
        </p>
      </div>
      <div className="mt-8">
        <p className="text-justify mt-10 dark:text-gray-100 leading-loose">
          {appStrings.analyzeHint}
        </p>
        <div className="my-4">
          {auth ? (
            <NavLink
              className="bg-primary-800 font-semibold text-white p-2 rounded-lg"
              to={`/result?qi=${content.id}`}
            >
              {appStrings.showAnalyze}
            </NavLink>
          ) : (
            <a
              className="bg-primary-800 font-semibold text-white p-2 rounded-lg"
              href={`${
                process.env.REACT_APP_AUTH_URL
              }?from=${encodeURIComponent(url)}`}
            >
              {appStrings.showAnalyze}
            </a>
          )}
        </div>
        <p className="text-primary-600 font-semibold mt-8 text-xl dark:text-primary-200">
          {appStrings.finalThanks}
        </p>
      </div>
    </animated.div>
  );
};

export default Result;
